import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "../../../assests/css/customer/CategoryCircles.css";
import AppContext from "../../../context/AppContext";

// =====================================================
// FIXED DISPLAY ORDER
// =====================================================
const SUBCATEGORY_ORDER = [
  "stitched",
  "unstitched",
  "western",
  "accessories",
];

const sortSubcategories = (list) => {
  return [...list].sort((a, b) => {
    const aTitle = (a?.title || "").toLowerCase().trim();
    const bTitle = (b?.title || "").toLowerCase().trim();

    let aIndex = SUBCATEGORY_ORDER.indexOf(aTitle);
    let bIndex = SUBCATEGORY_ORDER.indexOf(bTitle);

    if (aIndex === -1) aIndex = SUBCATEGORY_ORDER.length;
    if (bIndex === -1) bIndex = SUBCATEGORY_ORDER.length;

    return aIndex - bIndex;
  });
};

const CategoryCircles = ({ loadAllProductsWithCategory }) => {
  const {
    baseUrl,
    selectedCategory,
    storeSelectedSubcategory,
  } = useContext(AppContext);

  const [subcategories, setSubcategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const getCategoryIdFromUrl = () => {
    const path = window.location.pathname.toLowerCase();

    if (path.includes("/products/women")) return 1;
    if (path.includes("/products/men")) return 2;
    if (path.includes("/products/kids")) return 3;
    if (path.includes("/products/accessories")) return 4;

    return selectedCategory?.id || null;
  };

  // =====================================================
  // LOAD SUBCATEGORIES (sirf circles dikhane ke liye)
  // =====================================================
  // NOTE: Yahan koi auto-load/auto-select nahi karte.
  // "Pehli subcategory ke products apne aap load hon" ka
  // kaam ProductsPage.jsx apne useEffect mein pehle se
  // karta hai. Agar yahan bhi wahi kaam kiya jaye to do
  // parallel API calls race karte hain aur UI flicker karti
  // hai (pehle Accessories dikhti hai, fir sahi subcategory
  // aati hai). Isliye single source of truth ProductsPage
  // hi rahega — CategoryCircles sirf circles render karega
  // aur click hone par loadAllProductsWithCategory call karega.
  // =====================================================
  useEffect(() => {
    const loadSubcategories = async () => {
      const categoryId = getCategoryIdFromUrl();

      if (!categoryId) {
        setSubcategories([]);
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        const formData = new FormData();
        formData.append("mlcategory_id", categoryId);

        const response = await axios.post(
          `${baseUrl}/admin/subcategory/getAllSubcategories`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const data = response.data?.data || [];

        setSubcategories(sortSubcategories(data));
      } catch (error) {
        console.error(
          "SUBCATEGORY LOAD ERROR:",
          error.response?.data || error.message
        );

        setSubcategories([]);
      } finally {
        setLoading(false);
      }
    };

    loadSubcategories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUrl, selectedCategory?.id, window.location.pathname]);

  // =====================================================
  // SUBCATEGORY CLICK (manual click par hi products load hon)
  // =====================================================
  const handleSubcategoryClick = (sub) => {
    if (!sub?.id) return;

    if (typeof storeSelectedSubcategory === "function") {
      storeSelectedSubcategory(sub);
    }

    const categoryId =
      selectedCategory?.id || getCategoryIdFromUrl();

    if (typeof loadAllProductsWithCategory === "function") {
      loadAllProductsWithCategory(categoryId, sub.id, sub.title);
    }
  };

  if (loading) {
    return (
      <div className="category-circles-section">
        <p style={{ textAlign: "center", padding: "40px" }}>
          Loading categories...
        </p>
      </div>
    );
  }

  if (subcategories.length === 0) {
    return (
      <div className="category-circles-section">
        <p style={{ textAlign: "center", padding: "40px" }}>
          No subcategories found.
        </p>
      </div>
    );
  }

  return (
    <div className="mt-5 category-circles-section">
      <div className="category-circles-container">
        {subcategories.map((sub, index) => {
          if (!sub || sub.status !== "active") return null;

          const imageUrl = sub.image_url || null;

          return (
            <div
              key={sub.id}
              className="category-circle-wrapper"
              onClick={() => handleSubcategoryClick(sub)}
              style={{
                animationDelay: `${index * 0.2}s`,
                cursor: "pointer",
              }}
            >
              <div className="category-circle">
                <div className="circle-inner">
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt={sub.title || "Category"}
                      className="circle-image"
                      loading="lazy"
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        color: "#999",
                        fontSize: "13px",
                        padding: "10px",
                      }}
                    >
                      Image not available
                    </div>
                  )}
                  <div className="circle-overlay"></div>
                </div>
                <div className="circle-shine"></div>
              </div>

              <h3 className="category-name">{sub.title}</h3>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryCircles;